import { useCallback, useEffect, useState } from 'react'

const useGridColumns = (minWidth = 150, gap = 16) => {
	const [element, setElement] = useState<HTMLDivElement | null>(null)
	const [columns, setColumns] = useState(0)

	const ref = useCallback((el: HTMLDivElement | null) => {
		setElement(el)
	}, [])

	useEffect(() => {
		if (!element) return

		const update = () => {
			const width = element.clientWidth
			setColumns(Math.floor((width + gap) / (minWidth + gap)) || 1)
		}

		update()
		const observer = new ResizeObserver(update)
		observer.observe(element)
		return () => observer.disconnect()
	}, [element, minWidth, gap])

	return [ref, columns] as const
}

export default useGridColumns
